import { AlertsComponent } from './alerts/alerts.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from 'src/app/material-module';
import { LangComponent } from './lang/lang.component';


@NgModule({
  imports: [
    CommonModule , MaterialModule
  ],
  declarations: [AlertsComponent] ,
  exports: [AlertsComponent ]
})
export class ComponentsModule { }
